import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { TypeMappingRow } from "@common/helpers/chartOfAccountsTemplateTypeMapping";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import styles from "../ChartOfAccountsTemplateTypeMapping.module.scss";

export const TypeMappingNameCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TypeMappingRow, unknown>) => {
        const { name, codeText, kind } = row.original;
        const label = codeText ? `${codeText} - ${name}` : name;
        return (
            <ViewTableCell className={styles.nameCell}>
                <BreakableText
                    text={label}
                    showTooltip
                    className={kind === "group" ? styles.groupName : undefined}
                />
            </ViewTableCell>
        );
    },
);

TypeMappingNameCell.displayName = "TypeMappingNameCell";
